import { render } from "./WalletConnection.vue?vue&type=template&id=d3eeaabc"
import script from "./WalletConnection.vue?vue&type=script&lang=js"
export * from "./WalletConnection.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/WalletConnection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d3eeaabc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d3eeaabc', __exports__)) {
    api.reload('d3eeaabc', __exports__)
  }
  
  module.hot.accept("./WalletConnection.vue?vue&type=template&id=d3eeaabc", () => {
    api.rerender('d3eeaabc', render)
  })

}


export default __exports__